import { useRef } from "react";

function Modal(props) {
  const { children, isModal, back, data } = props;
  const modalRef = useRef(null);

  const handleClickOutsideModal = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      isModal && back();
    }
  };

  return (
    <>
      <div className={`relative z-10`}>
        {isModal && (
          <>
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
            <div
              onClick={handleClickOutsideModal}
              className="fixed inset-0  flex items-center justify-center"
            >
              <div
                ref={modalRef}
                data-cy={data}
                className="bg-white z-11 rounded-lg p-8"
              >
                {children}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Modal;
